import { HStack, StackProps, Text, colors } from "@biblioteksentralen/react";
import { ReactNode } from "react";

type Props = {
  label: string;
  children: ReactNode;
} & StackProps;

const LabelAndValue = ({ label, children, ...stackProps }: Props) => {
  return (
    <HStack gap="0" {...stackProps} flexWrap="wrap">
      <Text as="span" color={colors.grey60} marginRight="0.25rem">
        {label}:
      </Text>
      <Text as="span" color={colors.black} _firstLetter={{ textTransform: "uppercase" }}>
        {children}
      </Text>
    </HStack>
  );
};

export default LabelAndValue;
